/** @format */

import './gb-edit-table-items-dialog.scss';
import { map } from 'lodash';

export class GbEditTableItemsDialogController {
    constructor($mdDialog, items, widget) {
        'ngInject';

        this.$mdDialog = $mdDialog;
        this.items = items;
        this.widget = widget;

        this.order = 'order';
        this.page = 1;
        this.limit = 20;
        this.selection = [];
    }

    $onInit() {
        this.createSelection();
    }

    createSelection() {
        return map(this.items, (item) => {
            if (this.widget.hidden_items.indexOf(item.uuid) === -1) {
                this.selection.push(item.uuid);
            }
        });
    }

    convertSelection() {
        this.hiddenItems = [];

        return map(this.items, (item) => {
            if (this.selection.indexOf(item.uuid) === -1) {
                this.hiddenItems.push(item.uuid);
            }
        });
    }

    onSubmit() {
        this.convertSelection();
        return this.$mdDialog.hide(this.hiddenItems);
    }

    onCancel() {
        return this.$mdDialog.cancel();
    }
}
